/**
 * THIN ProductAttribute Provider (~30 lines)
 * All logic lives in hooks/catalog/useProductState.ts
 */
import { createContext, useContext, type ReactNode } from 'react'

import { useProductState } from '../../hooks/productView/useProductState'

import type { ProductAttributeContextValue } from '../../types'

const ProductAttributeContext = createContext<ProductAttributeContextValue | undefined>(undefined)

interface ProductAttributeProviderProps {
  children: ReactNode
  productSku: string
}

export function ProductAttributeProvider({ children, productSku }: ProductAttributeProviderProps) {
  const state = useProductState(productSku)

  return (
    <ProductAttributeContext value={state}>
      {children}
    </ProductAttributeContext>
  )
}

export function useProductAttributes(): ProductAttributeContextValue {
  const context = useContext(ProductAttributeContext)
  if (!context) {
    throw new Error('useProductAttributes must be used within a ProductAttributeProvider')
  }
  return context
}
